import {
  GET_EXPENSES,
  GET_EXPENSES_ERROR,
  GET_EXPENSES_SUCCESS,

  GET_RECEVABLE_PAYABLE,
  GET_RECEVABLE_PAYABLE_ERROR,
  GET_RECEVABLE_PAYABLE_SUCCESS,

  GET_INCOME_AND_EXPENSES_BY_MONTHS,
  GET_INCOME_AND_EXPENSES_BY_MONTHS_ERROR,
  GET_INCOME_AND_EXPENSES_BY_MONTHS_SUCCESS,

  GET_PROVIDENT_FUND,
  GET_PROVIDENT_FUND_ERROR,
  GET_PROVIDENT_FUND_SUCCESS,

} from './constants';

export default {
  [GET_EXPENSES](state) {
    state.expenses = [];
    state.error = false;
    state.loading = true;
    state.success = false;
  },
  [GET_EXPENSES_ERROR](state, payload) {
    state.error = payload;
    state.loading = false;
  },
  [GET_EXPENSES_SUCCESS](state, payload) {
    state.expenses = payload;
    state.loading = false;
    state.success = true;
  },

  [GET_RECEVABLE_PAYABLE](state) {
    state.recevablePayable = [];
    state.error = false;
    state.loading = true;
    state.success = false;
  },
  [GET_RECEVABLE_PAYABLE_ERROR](state, payload) {
    state.error = payload;
    state.loading = false;
  },
  [GET_RECEVABLE_PAYABLE_SUCCESS](state, payload) {
    state.recevablePayable = payload;
    state.loading = false;
    state.success = true;
  },

  [GET_INCOME_AND_EXPENSES_BY_MONTHS](state) {
    state.incomeAndExpensesByMonths = [];
    state.error = false;
    state.loading = true;
    state.success = false;
  },
  [GET_INCOME_AND_EXPENSES_BY_MONTHS_ERROR](state, payload) {
    state.error = payload;
    state.loading = false;
  },
  [GET_INCOME_AND_EXPENSES_BY_MONTHS_SUCCESS](state, payload) {
    state.incomeAndExpensesByMonths = payload;
    state.loading = false;
    state.success = true;
  },

  [GET_PROVIDENT_FUND](state) {
    state.providentFund = [];
    state.error = false;
    state.loading = true;
    state.success = false;
  },
  [GET_PROVIDENT_FUND_ERROR](state, payload) {
    state.error = payload;
    state.loading = false;
  },
  [GET_PROVIDENT_FUND_SUCCESS](state, payload) {
    state.providentFund = payload;
    state.loading = false;
    state.success = true;
  },
};



// WEBPACK FOOTER //
// ./src/components/Syndicates/Syndicate/Dashboard/mutations.js